"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaServicesPdfIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="16" height="16" x="4" y="4" fill="currentcolor" rx="2"/><rect width="10" height="2" x="7" y="8" fill="inherit" rx="1"/><path fill="inherit" d="M16.187 16h-3.373c-.45 0-.814-.222-.814-.497v-4.006c0-.275.364-.497.814-.497h3.373c.45 0 .813.222.813.497v4.006c0 .275-.364.497-.813.497"/><rect width="4" height="2" x="7" y="11" fill="inherit" rx="1"/><rect width="4" height="2" x="7" y="14" fill="inherit" rx="1"/></g></svg>`
}, props));
MediaServicesPdfIcon.displayName = 'MediaServicesPdfIcon';
var _default = exports.default = MediaServicesPdfIcon;